// extracted by mini-css-extract-plugin
export default {"container":"IntegrationRequestCard-module--container--94080","prompt":"IntegrationRequestCard-module--prompt--0dcba"};